import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import { useRef } from "react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = location.hash || window.location.hash;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const role = localStorage.getItem("ashland_role_hint") || "applicant";
    if (!sessionId) { navigate("/login"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id: sessionId, role });
        localStorage.removeItem("ashland_role_hint");
        setUser(data);
        window.history.replaceState({}, document.title, window.location.pathname);
        navigate(data.role === "admin" ? "/admin" : data.role === "employer" ? "/employer" : "/applicant");
      } catch {
        navigate("/login");
      }
    })();
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <Loader2 className="h-8 w-8 animate-spin text-amber-500" />
    </div>
  );
}
